<template>
  <div class="production">
    <div class="banner">
      <img
        width="100%"
        :src="headerBannerSrc"
        alt=""
      >
    </div>

    <div class="content">
      <div class="content-recommend center">
        <p class="content-tit">{{ details.Name }}</p>
        <div class="content-con">
          <img
            class="developer-avatar"
            width="400"
            :src="details.avatar"
          >
        </div>
        <div class="content-con content-box">
          <p class="cb-tit">介绍：</p>
          <p class="tit">所属团队：{{ details.Name }}</p>
          <p class="cb-txt">{{ details.instruction }}</p>
        </div>
      </div>

      <!-- 代表作品 -->
      <div class="content-item">
        <p class="content-tit">代表作品</p>
        <div class="content-con flex details-info">
          <div class="details-info-img developer">
            <div class="production-list flex">
              <div class="production-item noHover">
                <a @click="handleProduction(details)"><img :src="behalf.avatar"></a>
                <div class="production-info">
                  <p class="production-tit">{{ behalf.name }}</p>
                  <p class="production-subTit">团队: {{ details.Name }}</p>
                  <p class="production-desc">{{ behalf.instruction }}</p>
                </div>
              </div>
            </div>
            <!-- <img
              width="60%"
              :src="behalf.avatar"
              alt=""
            > -->
          </div>
          <div class="details-info-txt">
            <p class="details-info-txt-tit con-tit">
              创作思路：
            </p>
            <p class="con-txt">
              {{ behalf.instruction }}
            </p>
          </div>
        </div>
      </div>

      <div v-if="currentDevAllProducts.length" class="content-item">
        <p class="content-tit">更多作品</p>
        <div class="production-list more">
          <Row
            type="flex"
            justify="start"
            style="width: 100%"
          >
            <i-col
              v-for="(item, i) in currentDevAllProducts"
              :key="i"
              class="production-item"
              :xs="12"
              :sm="8"
              @click.native="handleProduction(item)"
            >
              <img
                width="100%"
                :src="item.avatar"
              >
              <div class="production-info">
                <p class="production-tit">{{ item.name }}</p>
                <p class="production-subTit">{{ item.subTitle }}</p>
                <p class="production-desc">{{ item.instruction }}</p>
              </div>
            </i-col>
          </Row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { os } from '@/utils/index'

const { isPc } = os()
const assetBasicCatalog = isPc ? 'pc' : 'mobile'
const basicSrc = `assets/images/developer/${assetBasicCatalog}`

export default {
  name: 'developer-details',
  // 引入的组件
  components: {},
  // 当前页面的数据定义
  data() {
    return {
      headerBannerSrc: require(`@/${basicSrc}/head-details-banner.jpg`),
      details: {},
      currentDevAllProducts: [],
      behalf: {}
    }
  },
  // 计算属性
  computed: {},
  // 页面初始化的时候执行的方法
  created() {},
  // html已经渲染并挂载后的执行方法
  mounted() {
    window.scrollTo(0, 0)
    this.getDetails()
    this.getProductsByDev()
  },
  // 当前页面的方法集合
  methods: {
    async getDetails() {
      this.$Loading.start()
      const { data } = await this.$api.getDevelopersDetails({
        id: this.$route.params.id
      })
      this.$Loading.finish()

      this.details = data
    },
    async getProductsByDev() {
      const { data } = await this.$api.getProductsByDev({
        developer: this.$route.params.id,
        cur: this.details.id
      })

      this.currentDevAllProducts = data
      this.behalf = this.currentDevAllProducts.shift()
    },
    handleProduction(item) {
      this.$router.push({
        path: `/experiences/${item.id}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.developer {
  background-color: transparent;
}

.production {
  background-color: #000;

	.production-item.noHover {
		.production-info {
			top: 265PX;
		}
		.production-tit {
			padding: 45PX;
		}
	}

  .content-recommend.center {

    .content-tit {
      text-align: center;
      letter-spacing: 2PX;
    }

    .content-box {
      margin-top: 90PX;
      padding: 70PX 50PX;
      color: #fff;
      background-color: #0000008a;
      text-align: left;
      .cb-tit{
        font-size: 20PX;
        font-weight: 900;
      }
      .tit{
        font-size: 20PX;
        margin: 40PX 0;
        font-weight: 900;
      }
      .cb-txt{
        font-size: 16PX;
        text-align: justify;
        line-height: 28PX;
        color: #bdbebe;
      }
    }
  }

  .developer-avatar {
    width: 450PX;
    height: 450PX;
    border-radius: 100%;
  }

  .details-btn {
    margin-top: 40PX;
  }

  .content-item {
    background-image: url(https://game.gtimg.cn/images/roblox/web201904/collect/bg01.jpg);
    background-repeat: repeat-y;
    .content-tit{
        padding: 70PX 0;
        font-size: 20PX;
        letter-spacing: 2PX;
    }
    .details-info{
      padding-top: 0;
      .con-txt{
          color: #bbb;
      }
    }
  }

  .details-info {
    padding-top: 125PX;
    .production-item{
        margin-bottom: 0;
    }
  }

  .details-info-img {
    width: 440PX;
    display: flex;
    justify-content: center;
    align-items: center;

    &.developer {
      img {
        width: 100%;
        height: 100%;
        border-radius: 0 !important;
      }
    }
  }

  .details-info-txt {
    padding: 45PX 55PX;
    width: 760PX;
    text-align: left;
    color: #fff;
    height: 380PX;
    background-color: #0000008a;

    &-tit {
      margin-bottom: 40PX;
    }

    &-desc {
      font-size: 14PX;
    }
  }

  .details-desc-tit {
    padding-top: 50PX;
    padding-bottom: 40PX;
  }
}

@media screen and (max-width: 800px) {
  .production {
    .content-recommend.center {
      .content-tit {
        padding: 100px 0;
      }

      .content-box {
        padding: 40px;
        font-size: 14px;
        min-height: auto;
        margin: 80px auto 0 auto;
        width: 90%;
      .cb-tit{
        font-size: 30px;
      }
      .tit{
        font-size: 28px;
        margin: 40px 0;
      }
      .cb-txt{
        font-size: 24px;
        line-height: 36px;
      }
      }
    }
    .content-item{
        .content-tit{
            padding: 100px 40px;
            font-size: 32px;
        }
        .details-info{
            padding-top: 0;
            .con-txt{
                color: #bdbebe;
            }
        }
      .production-item:nth-child(2n){
          margin-left: 5%;
      }
    }
    .developer-avatar {
      width: 288px;
      height: 288px;
      border-radius: 100%;
    }

    .details-btn {
      margin-top: 75px;
    }

    .details-info {
      padding-top: 45px;
    }
    .details-info-img {
      width: 100%;
      .production-item{
          margin: 0 auto;
          width: 80%;
          height: 360px;
          img{
            height: 260px;
          }
          .production-info{
              top: 65%;
              .production-tit{
                  font-size: 24px;
                  padding: 50px 20px;
              }
          }
      }
    }

    .details-info-txt {
      margin-top: 45px;
      padding: 50px 40px;
      width: 100%;
      height: auto;

      &-tit {
        margin-bottom: 40px;
        font-size: 28px;
      }
      .con-txt{
        font-size: 24px;
        line-height: 36px;
      }
    }

    .details-desc-tit {
      padding-top: 50px;
      padding-bottom: 40px;
    }
  }
}
</style>
